import * as Yup from 'yup';
import i18n from 'i18next';

const passwordRegex = /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/gm;

export const registerValidation = Yup.object().shape({
    name: Yup.string().required(() => i18n.t('auth.register_form.input_name_required')),
    email: Yup.string()
        .email(() => i18n.t('auth.register_form.input_email_wrong_format'))
        .required(() => i18n.t('auth.register_form.input_email_required')),
    password: Yup.string()
        .matches(passwordRegex, () => i18n.t('auth.register_form.password_length'))
        .required(() => i18n.t('auth.register_form.password_required')),
});
